import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFoundComponent from '../components/404.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
        title: '枫瑞七七旅行手册'
    }
},
{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
},
{
    path: '/map',
    name: 'BaiduMap',
    component: () => import( /* webpackChunkName: "map" */ '../views/BaiduMap.vue'),
    meta: {
        title: '地图'
    }
},
{
    path: '/maps',
    name: 'Maps',
    component: () => import( /* webpackChunkName: "map" */ '../views/Example.vue'),
    meta: {
        title: '地图'
    }
},
{ path: '*', component: NotFoundComponent }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    console.log(to)
    next();
});

export default router
